import { BoundType } from "utils/enums";
import { BaseDatasetDTO } from "./BaseDatasetDTO";

// eslint-disable-next-line import/prefer-default-export
export class DatasetInfo extends BaseDatasetDTO {
    groupTitle: string | null = null;

    categoryTitle: string | null = null;

    decimalPlaces: number = 0;

    boundToId: string | null = null;

    boundToType: BoundType | null = null;

    constructor(data: Partial<DatasetInfo>) {
      super(data);
        if (data) {
            Object.assign(this, data)
        }
    }

    toString(): string {
        let tmp = this.title || "";

        if (this.unit) {
            tmp += ` | ${this.unit}`;
        }

        if (this.groupTitle) {
            tmp += ` | ${this.groupTitle}`;
        }

        return tmp;
    }
}